export default angular.module('tooltip', [])
    /**
     * @ngdoc controller
     * @name tooltip.controller:tooltip
     * @description
     * Scope for a group of tooltips
     */
    // @ngInject
    .controller('tooltipGroup', function ($scope) {
        var _active_tooltip = null;

        $scope.isActive = function (tooltip) {
            return tooltip === _active_tooltip;
        };

        $scope.setActiveTooltip = function (tooltip) {
            return (_active_tooltip = tooltip);
        };

        $scope.toggleTooltip = function (tooltip, override) {
            if (typeof override === 'boolean') {
                return $scope.setActiveTooltip(override ? tooltip : null);
            }
            $scope.setActiveTooltip($scope.isActive(tooltip) ? null : tooltip);
        };
    })
    /**
     * @ngdoc controller
     * @name tooltip.controller:tooltip
     * @description
     * Scope for a single tooltip
     */
    // @ngInject
    .controller('tooltip', function ($scope) {
        $scope.tooltip = null;
    })
    /**
     * @ngdoc directive
     * @name tooltip.directive:tooltipGroup
     * @restrict A
     * @description
     * Creates the scope of a group of related tooltips
     */
    // @ngInject
    .directive('tooltipGroup', function () {
        return {
            scope: true,
            controller: 'tooltipGroup',
            restrict: 'A',
            link: function ($scope, $element) {
                $element.addClass('field-group-tooltip');
            }
        };
    })
    /**
     * @ngdoc directive
     * @name tooltip.directive:tooltip
     * @restrict A
     * @description
     * Creates the scope of a single tooltip and manages active classes
     */
    // @ngInject
    .directive('tooltip', function () {
        return {
            scope: true,
            controller: 'tooltip',
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                var active_class = attrs.toggleClass || 'tooltip--active';
                $scope.tooltip = $element;
                $scope.$watch(function () {
                    return $scope.isActive($scope.tooltip);
                }, function (is_active) {
                    $element.toggleClass(active_class, is_active);
                });
                if ('activeTooltip' in attrs) {
                    $scope.setActiveTooltip($scope.tooltip);
                }
            }
        };
    })
    /**
     * @ngdoc directive
     * @name tooltip.directive:toggleTooltip
     * @restrict A
     * @description
     * Toggle the current tooltip on focus/blur or click
     */
    // @ngInject
    .directive('toggleTooltip', function ($document) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                if ($element[0].tagName === 'INPUT' || $element[0].tagName === "SELECT") {
                    $element.on('focus', function (e) {
                        e.preventDefault();
                        $scope.$apply(function () {
                            $scope.setActiveTooltip($scope.tooltip);
                        });
                    });
                }
                else {
                    $element.on('click touchend', function (e) {
                        e.preventDefault();
                        $scope.$apply(function () {
                            var active_class = attrs.toggleClass || 'toggle-tooltip--active';
                            $scope.toggleTooltip($scope.tooltip);
                            $element.toggleClass(active_class, $scope.isActive($scope.tooltip));
                            if (attrs.toggleTooltipScroll && $scope.isActive($scope.tooltip)) {
                                var offset = parseInt(attrs.toggleTooltipScrollOffset, 10) || 0;
                                $document.scrollToElement($scope.tooltip, offset);
                            }
                        });
                    });
                }
            }
        };
    });
